import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Drawer, Form, Select, Divider } from 'antd';

import FormHealthDocumentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-health-document-template';
import FormOtherDocumentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-other-document-template';
import FormAssessmentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-assessment-template';
import FormCertificationTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-certification-template';
import FormLicenseTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-license-template';
import DocumentTemplateForm from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/document-template-form';
import FormActions from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/form-actions';

import {
  BACKGROUND_IDENTIFICATION_TYPE,
  IMMIGRATION_TYPE,
  LICENSE_TYPE,
  CERTIFICATION_TYPE,
  ASESSMENT_TYPE,
  HEALTH_DOC,
  OTHER_DOCUMENT,
} from './compliance-item-types';

const ItemTypes = [
  BACKGROUND_IDENTIFICATION_TYPE,
  IMMIGRATION_TYPE,
  LICENSE_TYPE,
  CERTIFICATION_TYPE,
  ASESSMENT_TYPE,
  HEALTH_DOC,
  OTHER_DOCUMENT,
];

export const ItemTypeTitles = {
  [BACKGROUND_IDENTIFICATION_TYPE]: 'Background and Identification',
  [IMMIGRATION_TYPE]: 'Immigration',
  [LICENSE_TYPE]: 'License',
  [CERTIFICATION_TYPE]: 'Certification',
  [ASESSMENT_TYPE]: 'Assessment',
  [HEALTH_DOC]: 'Health Document',
  [OTHER_DOCUMENT]: 'Other Document',
};

function AddItemForm({ dismiss, handleSubmit, form }) {
  const [currentType, setCurrentType] = useState();

  function renderForm(type) {
    switch (type) {
      case BACKGROUND_IDENTIFICATION_TYPE:
        return (
          <DocumentTemplateForm
            categories={['background', 'identity', 'facility_required']}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
            showExpiration
            form={form}
          />
        );
      case IMMIGRATION_TYPE:
        return (
          <DocumentTemplateForm
            categories={['immigration']}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{ active: true, expirationType: 'NON_EXPIRABLE' }}
            showExpiration
            form={form}
          />
        );
      case LICENSE_TYPE:
        return (
          <FormLicenseTemplate
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
            showExpiration
            form={form}
          />
        );
      case CERTIFICATION_TYPE:
        return (
          <FormCertificationTemplate
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
            showExpiration
            form={form}
          />
        );
      case ASESSMENT_TYPE:
        return (
          <FormAssessmentTemplate
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{
              active: true,
              expirationType: 'COMPLETION_DATE',
              daysToExpiry: 365,
            }}
            showExpiration
            form={form}
          />
        );
      case HEALTH_DOC:
        return (
          <FormHealthDocumentTemplate
            showSeason={false}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{
              active: true,
              expirationType: 'COMPLETION_DATE',
              daysToExpiry: 365,
            }}
            showExpiration
            form={form}
          />
        );
      case OTHER_DOCUMENT:
        return (
          <FormOtherDocumentTemplate
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type)}
            initialValues={{ active: true, expirationType: 'NON_EXPIRABLE' }}
            showExpiration
            form={form}
          />
        );
    }
  }

  return (
    <React.Fragment>
      <Form layout="vertical">
        <Form.Item
          label="Please select a Compliance Item Type"
          name="todoItemType"
        >
          <Select
            size="large"
            onChange={(value) => {
              setCurrentType(value);
            }}
            showSearch
          >
            {ItemTypes.map((type) => {
              return (
                <Select.Option key={type} value={type}>
                  {ItemTypeTitles[type]}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>

      {currentType && (
        <React.Fragment>
          <Divider plain>New {ItemTypeTitles[currentType]} Item</Divider>
          {renderForm(currentType)}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

AddItemForm.propTypes = {
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

export function CandidateAssignmentItemAddModal({ dismiss, handleSubmit }) {
  const [form] = Form.useForm();

  return (
    <Drawer
      title="Add Compliance Item"
      visible={true}
      onClose={dismiss}
      width={550}
      footer={<FormActions onCancel={dismiss} onSubmit={form.submit} />}
    >
      <AddItemForm form={form} dismiss={dismiss} handleSubmit={handleSubmit} />
    </Drawer>
  );
}

CandidateAssignmentItemAddModal.propTypes = {
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
